"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _theme = require("../theme.css");
var _indicator = require("./indicator.css");
const IndicatorWrapper = ({
  loaded,
  children
}) => /*#__PURE__*/_react.default.createElement("div", {
  "data-testid": "preview-status-indicator",
  "aria-live": "assertive",
  className: `${_theme.themeClass} ${_indicator.wrapperStyle[loaded ? `loaded` : `default`]}`
}, children);
var _default = IndicatorWrapper;
exports.default = _default;